/**
 * Empty-state greeting prefix for D2D Energy Assistant.
 * "Hi Luther" from user.name first token; "Hi" when name is missing/email-like.
 */
export function assistantHiPrefix(user) {
  const name = String(user?.name || '').trim();
  if (!name || name.includes('@')) return 'Hi';
  const first = name.split(/\s+/)[0];
  return first ? `Hi ${first}` : 'Hi';
}
